export default "__VITE_ASSET__8b9d01fb__"